<ng-container *ngFor="let link of links; let i = index">
  <app-contracts-pill
    #pill
    *ngIf="expanded || i < visibleCount"
    [class.is-first]="i === 0"
    [content]="link"
    linkType="contractPreviewLink"
  ></app-contracts-pill>
</ng-container>

<!-- Like the task tags (#4752): "+N" expands the row to every project, "show less" folds it back. -->
<button
  *ngIf="hiddenCount > 0"
  type="button"
  class="more"
  [attr.aria-expanded]="expanded"
  (click)="toggle($event)"
>
  <ng-container *ngIf="expanded; else count" i18n="@@showLess">show less</ng-container>
  <ng-template #count>+{{ hiddenCount }}</ng-template>
</button>
